import * as i18n from '@/i18n';
import cronstrue from 'cronstrue/i18n';
import moment from 'moment';

const mutations = {
  closeHovers: state => {
    state.show = null;
    state.showMessage = null;
  },
  toggleShell: (state) => {
    state.showShell = !state.showShell;
  },
  showHover: (state, value) => {
    if (typeof value !== 'object') {
      state.show = value;
      return;
    }

    state.show = value.prompt;
    state.showMessage = value.message;
    state.showConfirm = value.confirm;
    state.showData = value.data;
  },
  showError: (state, value) => {
    state.show = 'error';
    state.showMessage = value;
  },
  showSuccess: (state, value) => {
    state.show = 'success';
    state.showMessage = value;
  },
  setLoading: (state, value) => { state.loading = value; },
  setReload: (state, value) => { state.reload = value; },
  setEditorSaving: (state, value) => { state.editorSaving = value; },
  setIsPrompt: (state, value) => { state.isPrompt = value; },
  setIsFaldon: (state, value) => { state.isFaldon = value;},
  setIsCodeVisible: (state, value) => { state.isCodeVisible = value; },
  setHandleRecord: (state, value) => { state.handleRecord = value; },
  setHandleArchivo: (state, value) => { state.handleArchivo = value; },
  setIdCoupon: (state, value) => { state.idCoupon = value; },
  setEmailCoupon: (state, value) => { state.emailCoupon = value; },
  setParentHandle: (state, value) => { state.parentHandle = value; },
  setAccountHandle: (state, value) => { state.accountHandle = value; },
  setAccountHandleJoin: (state, value) => { state.accountHandleJoin = value; },
  setAccountKeyJoin: (state, value) => { state.accountKeyJoin = value; },
  setRegistrationId: (state, value) => { state.registrationId = value; },
  setCreateAccountCoupon: (state, value) => { state.createAccountCoupon = value; },
  setJoinLink: (state, value) => { state.joinLink = value; },
  setHandleOpenSpace: (state, value) => { state.handleOpenSpace = value; },
  setReferrerCode: (state, value) => { state.referrerCode = value; },
  setIsDelete: (state, value) => { state.isDelete = value; },
  setIsRename: (state, value) => { state.isRename = value; },
  setIsPreview: (state, value) => { state.isPreview = value; },
  setSortOrder: (state, value) => { state.sortOrder = value; },
  setLinkInbox: (state, value) => { state.linkInbox = value; },
  setPermissions: (state, value) => { state.permissions = value; },
  setIsMaxStorage: (state, value) => { state.isMaxStorage = value; },
  setPermissionsSharedDrive: (state, value) => { state.permissionsSharedDrive = value; },
  setLinkSharedDrive: (state, value) => { state.linkSharedDrive = value; },
  setHandleSharedDrive: (state, value) => { state.handleSharedDrive = value; },
  setSearchVal: (state, value) => { state.searchVal = value; },
  setFilterTag: (state, value) => { state.filterTag = value; },
  setIsItemOptions: (state, value) => { state.isItemOptions = value; },
  setIsMultiSelectedCheck: (state, value) => { state.isMultiSelectedCheck = value; },
  setUser: (state, value) => {
    if (value === null) {
      state.user = null;
      return;
    }

    let locale = value.locale;

    if (locale === '') {
      locale = i18n.detectLocale();
       if (locale == 'es' || locale == 'en')
       {
          value.locale = locale;
       }
       else
       {
          locale = 'en';
          value.locale = 'en';
       }
    }

    cronstrue.defaultLocale = locale;
    moment.locale(locale);
    i18n.default.locale = locale;
    state.user = value;
  },
  setJWT: (state, value) => (state.jwt = value),
  multiple: (state, value) => (state.multiple = value),
  addSelected: (state, value) => (state.selected.push(value)),
  addPlugin: (state, value) => {
    state.plugins.push(value);
  },
  /*addDownload: (state, value) => (state.downloads.push(value)),
  addUpload: (state, value) => (state.uploads.push(value)),
  addDownloadTransfers: (state, value) => (state.downloadTransfers = [...value]),
  addUploadTransfers: (state, value) => (state.uploadTransfers = [...value]),*/
  removeSelected: (state, value) => {
    let i = state.selected.indexOf(value);
    if (i === -1) return;
    state.selected.splice(i, 1);
  },
  resetSelected: (state) => {
    state.selected = [];
  },
  updateUser: (state, value) => {
    if (typeof value !== 'object') return;

    for (let field in value) {
      if (field === 'locale') {
        cronstrue.defaultLocale = value[field];
        moment.locale(value[field]);
        i18n.default.locale = value[field];
      }

      state.user[field] = value[field];
    }
  },
  updateTransferProgress: (state, {index, value}) => {
    if (state.req.items && state.req.items.length > 0) {
          state.req.items[index].progress = value;
    }
  },
  updateRequest: (state, value) => {
    state.oldReq = state.req;
    state.req = value;
  },
  updateNextSnapshots: (state, value) => {
    state.nextSnapshots = value;
  },
  updateLastSnapshots: (state, value) => {
    state.lastSnapshots = value;
  },
  updateInvoices: (state, value) => {
    state.invoices = value;
  },
  updateActiveSessionHandle: (state, value) => {
    state.activeSessionHandle = value;
  },
  updateActiveSessions: (state, value) => {
    state.activeSessions = value;
  },
  updateInactiveSessions: (state, value) => {
    state.inactiveSessions = value;
  },
  updateClipboard: (state, value) => {
    state.clipboard.key = value.key;
    state.clipboard.items = value.items;
  },
  resetClipboard: (state) => {
    state.clipboard.key = '';
    state.clipboard.items = [];
  },
  setProgress: (state, value) => {
    state.progress = value;
  },
  setUserInfo(state, value) {
    state.userInfo = value;
  },
  setAccountInfo(state, value) {
    state.accountInfo = value;
  },
  setInvoicingInfo(state, value) {
    state.invoicingInfo = value;
  }
};

export default mutations;
